<template>
  <div>
    <!-- <p
      class="dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right pt-6"
    >
      © {{ new Date().getFullYear() }}. FF All rights reserved.
    </p> -->
  </div>
</template>
